import { useQuery } from '@tanstack/react-query'
import { Card } from '@/components/ui/Card'
import { Spinner } from '@/components/ui/Spinner'
import { Alert } from '@/components/ui/Alert'
import { legalDocumentsService } from '@/services/legalDocuments'
import { getErrorMessage } from '@/services/api'

export default function RepairsReplacements() {
  const { data: document, isLoading, error } = useQuery({
    queryKey: ['activeRepairsReplacements'],
    queryFn: () => legalDocumentsService.getActiveDocument('repairs_replacements'),
    retry: 1,
  })

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="flex justify-center items-center h-64">
          <Spinner size="lg" />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <Alert
          variant="error"
          message={getErrorMessage(error) || 'Failed to load Repairs & Replacements Policy'}
        />
      </div>
    )
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
      <Card className="p-4 sm:p-6 md:p-8">
        <div className="mb-6 sm:mb-8 pb-4 sm:pb-6 border-b">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            {document?.title || 'Repairs & Replacements'}
          </h1>
          {document?.effective_date && (
            <p className="text-sm sm:text-base text-gray-600">
              Effective Date: {new Date(document.effective_date).toLocaleDateString()}
            </p>
          )}
          <p className="text-sm text-gray-500 mt-1">Version: {document?.version}</p>
        </div>

        <div
          className="prose prose-sm sm:prose md:prose-lg max-w-none prose-headings:text-gray-900 prose-p:text-gray-700 prose-a:text-primary-600"
          dangerouslySetInnerHTML={{ __html: document?.content_html || '' }}
        />

        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t text-xs sm:text-sm text-gray-500">
          <p>
            Last updated: {document?.created_at ? new Date(document.created_at).toLocaleDateString() : 'N/A'}
          </p>
        </div>
      </Card>
    </div>
  )
}
